/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

// project imports
import { SalesList, ItemsList, SalesEdit, ItemsEdit, SalesDashboard, ItemsView } from 'features/components/base/sales';

/**
 * routing for sales components
 * 
 * @param props
 * 
 * @return routing for sales components
 * 
**/

export class SalesRouter extends Component {

    render() {
        return (
            <Switch>
                <Route exact path={`/sales`} component={SalesList} />
                <Route exact path={[`/sales/create`, `/sales/edit/:salesId`]} component={SalesEdit} />

                <Route exact path={`/sales/dashboard/:salesId`} component={SalesDashboard} />
                <Route exact path={`/sales/dashboard/:salesId/itemsview/:itemsId`} component={ItemsView} />
                <Route exact key="item-list" path={`/sales/items`} component={ItemsList} />
                <Route exact key="sale-item-list" path={`/sales/items/:saleId`} component={ItemsList} />
                <Route exact path={[`/sales/item/create`, `/sales/items/edit/:itemsId`]} component={ItemsEdit} />

                <Redirect to="/home" />
            </Switch>
        );
    }
}

export default connect(state => state)(SalesRouter);